<template>
    <div class="flex icon">
        <div class="icon">
            <div class="icon-back" v-if="type === 'new'">
                <img class="icon-img" v-show="isPlay && playVal == 1" src="https://m.elongstatic.com/year-wish/audio_play_1.png" />
                <img class="icon-img" v-show="isPlay && playVal == 2" src="https://m.elongstatic.com/year-wish/audio_play_2.png" />
                <img class="icon-img" v-show="isPlay && playVal == 3" src="https://m.elongstatic.com/year-wish/audio_play_3.png" />      
                <img class="icon-img" v-show="!isPlay" src="http://m.elongstatic.com/year-wish/voice-icon-2x.png" />      
            </div>
            <div class="icon-back" v-else-if="type === 'yellow'">
                <img class="icon-img" v-show="isPlay && playVal == 1" src="https://m.elongstatic.com/year-wish/audio_play_yellow_1.png" />
                <img class="icon-img" v-show="isPlay && playVal == 2" src="https://m.elongstatic.com/year-wish/audio_play_yellow_2.png" />
                <img class="icon-img" v-show="isPlay && playVal == 3" src="https://m.elongstatic.com/year-wish/audio_play_yellow_3.png" />      
                <img class="icon-img" v-show="!isPlay" src="https://m.elongstatic.com/year-wish/audio_play_yellow_3.png" />     
            </div>
            <div class="icon-back" v-else>
                <img class="icon-img icon-img2" v-show="isPlay && playVal == 1" src="https://m.elongstatic.com/mall-v2/gift/play1.png" />
                <img class="icon-img icon-img2" v-show="isPlay && playVal == 2" src="https://m.elongstatic.com/mall-v2/gift/play2.png" />
                <img class="icon-img icon-img2" v-show="isPlay && playVal == 3" src="https://m.elongstatic.com/mall-v2/gift/play3.png" />      
                <img class="icon-img icon-img2" v-show="!isPlay" src="https://m.elongstatic.com/mall-v2/gift/play3.png" />     
            </div>
        </div>
        <div :class="{'second2': type !== 'new' && type !== 'yellow',  'second': true, 'second-yellow': type === 'yellow'}">{{second}}"</div>
    </div>
</template>

<script>
export default {
    props:{
        isPlay:{
            type:Boolean,
            default: false,
        },
        second:{
            type: Number,
            default: 0,
        },
        type:{
            type: String,
            default: 'new',
        },
    },
    watch:{
        isPlay(val){
            if(val){
                this.play();
            }else{
                if(this.time){
                    clearInterval(this.time)
                }
                this.stop();
            }
        }
    },
    data(){
        return {
            time:null,
            playVal: 0
        }
    },
    methods:{
        play(){
            this.time = setInterval(() => {
                this.playVal = this.playVal === 3 ? 0 : this.playVal + 1
            }, 500)
        },
        stop(){
            if(this.time){
                clearInterval(this.time)
            }
            this.playVal = 3;
        }
    }
}
</script>

<style lang="scss" scoped>
.icon-back{
    width: 26px;
    height: 26px;
}
.icon{
    // width: 26px;
    // height: 26px;
    .icon-img{
        display: block;
        width: 26px;
        height: 26px;
    }
    .icon-img2{
        width: 34px;
        height: 34px;
        margin-top: 22px;
    }
}
.flex{
    display: flex;
    align-items: center;
}
.second{
    height: 26px;
    font-size: 14px;
    line-height: 28px;
    color: #333;
    font-weight: 600;
}
.second2{
    font-size: 28px!important;
    line-height: 28px!important;
    position: absolute!important;
    top: 27px!important;
    left: 75px!important;
}
.second-yellow{
    color: #980F16!important;
}

//当屏幕最小宽度为992px 
@media screen and (max-width : 500px) {
    .second{
        height: 26px;
        font-size: 14px;
        line-height: 28px;
        color: #333;
        font-weight: 600;
        position: absolute;
        top: 10px;
        left: 46px;
    }
}

</style>